import { useEffect, useState } from 'react';

/**
 * The current time, re-read on each minute boundary — so a class that has ended
 * stops being "up next", and the greeting turns at noon, without a reload.
 */
export default function useMinuteClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let interval;
    const timeout = setTimeout(() => {
      setNow(new Date());
      interval = setInterval(() => setNow(new Date()), 60_000);
    }, 60_000 - (Date.now() % 60_000));
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, []);

  return now;
}
